import { EventEmitterInterface } from 'pf-frontend-common/src/module/event/emitter.interface';

import { AgentModel } from 'common/data/agent/model';
import { arrayFind } from 'common/helper/array/find';
import { AgentCardCommonActionInterface } from 'common/module/agent/card-common/action.interface';
import { AgentCardCommonTemplatePropsInterface } from 'common/module/agent/card-common/template-props.interface';
import { AgentListCommonStrategyEvent } from 'common/module/agent/list-common/strategy.event';
import { AgentListCommonStrategyInterface } from 'common/module/agent/list-common/strategy.interface';
import { AgentListCommonTemplatePropsInterface } from 'common/module/agent/list-common/template-props.interface';

export class AgentListCommonStrategy implements AgentListCommonStrategyInterface {
  /**
   * Constructor
   */
  constructor(private eventEmitter: EventEmitterInterface) {}

  /**
   * @inheritDoc
   */
  public getEventEmitter(): EventEmitterInterface {
    return this.eventEmitter;
  }

  /**
   * @inheritDoc
   */
  public clickCall(e: Event, agentModel: AgentModel, state: AgentListCommonTemplatePropsInterface): void {
    // Show number for agent
    const action = {
      showPhoneNumber: true,
    };

    // Update agent cards
    this.updateAgentCards(agentModel.id, action, state.agents);
  }

  /**
   * Update action of agent cards
   */
  public updateAgentCards = (
    agentId: string,
    action: AgentCardCommonActionInterface,
    agentCards: AgentCardCommonTemplatePropsInterface[]
  ): void => {
    const card = arrayFind(agentCards, (agentCard) => agentCard.agent.id === agentId);

    card.action = {
      ...card.action,
      ...action,
    };

    this.eventEmitter.emit(AgentListCommonStrategyEvent.updateAgentCards, agentCards);
  };
}
